import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
//import * as React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
//import reportWebVitals from "./reportWebVitals";
//import * as serviceWorker from "./serviceWorker";
import { AuthProvider } from "./providers/authProvider";
import themes from './themes';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    //<React.StrictMode>
        <AuthProvider>
            <ChakraProvider theme={themes}>
                <ColorModeScript />
                <App />
            </ChakraProvider>
        </AuthProvider>
    //</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorker.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals()
